import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { PageList } from './page-list';
export const SpecificPageList = props => /*#__PURE__*/React.createElement(PageList, _extends({}, props, {
  isSpecificPageList: true
}));
//# sourceMappingURL=specific-page-list.js.map